/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Flex, Button } from "@chakra-ui/react";
import { CashCenterDetails } from "../../../components/cashCenter/cash-center-details";

export default function Summary({
  cashCenter,
  onCreateCashCenter,
  editing,
  onPrevStep,
}) {
  const [payload, setPayload] = useState({});
  useEffect(() => {
    setPayload(createPayload(cashCenter));
  }, []);
  const createPayload = (data) => {
    const _cashCenter = {
      name: data.name,
      type: data.type,
      primaryCurrency: data.primaryCurrency,
      barcode: data.barcode,
      locationId: data.locationId,
      status: data.status,
      longitude: data.longitude,
      latitude: data.latitude,
      loadingBayArea: data.loadingBayArea,
      loadingBayCapacity: data.loadingBayCapacity,
      country: data.country,
      state: data.state,
      emirate: data.emirate,
      city: data.city,
      postalCode: data.postalCode,
      address: data.address,
      firstServiceDate: data.firstServiceDate,
      inactiveDate: data.inactiveDate,
      serviceDays: data.serviceDays,
      comments: data.comments,
      requestedBy: data.requestedBy,
      offices: data.offices.map((elm) => ({
        officeId: elm.officeId,
        officeName: elm.officeName,
        officeType: elm.officeType,
        country: elm.country,
        state: elm.state,
        emirate: elm.emirate,
        city: elm.city,
        postalCode: elm.postalCode,
        address: elm.address,
        barcode: elm.barcode,
        startDate: elm.startDate,
        inactiveDate: elm.inactiveDate,
        status: elm.status,
        longitude: elm.longitude,
        latitude: elm.latitude,
        operationalWindows: elm.operationalWindows,
      })),
      operationalWindows: data.operationalWindows.map((elm) => ({
        startDateTime: elm.startDateTime,
        endDateTime: elm.endDateTime,
        cutOffTime: elm.cutOffTime,
      })),
      insuranceLimits: data.insuranceLimits.map((elm) => ({
        customerId: elm.customerId,
        currency: elm.currency,
        area: elm.area,
        limit: elm.limit,
      })),
      contactPersons: data.contactPersons.map((elm) => ({
        firstName: elm.firstName,
        lastName: elm.lastName,
        mobileNo: elm.mobileNo,
        email: elm.email,
        personalMobileNo: elm.personalMobileNo,
        officeNo: elm.officeNo,
        designation: elm.designation,
      })),
      escalationGroups: data.escalationGroups.map((elm) => ({
        region: elm.region,
        routeNo: elm.routeNo,
        escalationLevel: `${elm.escalationLevel}`,
        inAppRecipients: elm.inAppRecipients.map((rec) => rec.item),
        emailRecipients: elm.emailRecipients.map((rec) => rec.item),
        callRecipients: elm.callRecipients.map((rec) => rec.item),
      })),
      internalSLAs: data.internalSLAs.map((elm) => ({
        region: elm.region,
        serviceType: elm.serviceType,
        activityType: elm.activityType,
        responseTime: elm.responseTime,
        attendedTime: elm.attendedTime,
        resolutionTime: elm.resolutionTime,
      })),
    };
    if (editing) {
      _cashCenter.id = data?.id || "";
    }
    return _cashCenter;
  };
  return (
    <>
      <CashCenterDetails cashCenter={payload} />
      <Flex
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        <Button onClick={onPrevStep}>Back</Button>
        <Button
          onClick={() => {
            onCreateCashCenter(payload);
          }}
        >
          {editing ? "Update Cash Center" : "Create Cash Center"}
        </Button>
      </Flex>
    </>
  );
}
